import { Box } from "@mui/material";
import { memo } from "react";
import { IDashboardTableProps } from "./models";
import { DataGrid, GridColDef, ptBR, enUS, esES } from "@mui/x-data-grid";
import { DashboardNoData } from "../DashboardNoData/DashboardNoData";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "components.panel.";

export const DashboardTable = memo(
  ({ data, columns }: IDashboardTableProps) => {
    const {
      t,
      i18n: { language: lang },
    } = useTranslation();

    const currentData = data
      ? data
          .sort((a, b) => (a.count < b.count ? 1 : a.count > b.count ? -1 : 0))
          .map((item, index) => ({ id: index + 1, ...item }))
      : [];

    const defaultColumns: GridColDef<any>[] = [
      {
        field: "ticketChannelName",
        headerName: `${t(TRANSLATION_PATH + "ticketChannelName")}`,
        flex: 1,
      },
      {
        field: "count",
        headerName: `${t(TRANSLATION_PATH + "count")}`,
        flex: 1,
      },
    ];

    if (!data || data.length === 0) {
      return <DashboardNoData />;
    }

    return (
      <Box
        sx={(t) => ({
          mt: 2,
          height: "100%",
          backgroundColor: t.palette.background.default,
          border: `1px solid ${t.palette.divider}`,
          borderRadius: 2,
          overflow: "hidden",
        })}
      >
        <DataGrid
          columns={columns ?? defaultColumns}
          rows={currentData}
          paginationMode="client"
          sx={{ height: "100%", maxHeight: "70vh", border: "none" }}
          hideFooterPagination
          localeText={
            lang === "es-ES"
              ? esES.components.MuiDataGrid.defaultProps.localeText
              : lang === "en-US"
              ? enUS.components.MuiDataGrid.defaultProps.localeText
              : ptBR.components.MuiDataGrid.defaultProps.localeText
          }
        />
      </Box>
    );
  }
);
